import { useDispatch, useSelector } from "react-redux";
import { store, type AppDispatch, type RootState } from "../store.js";
import { bindActionCreators } from "redux";
import { useMemo } from "react";
import type { PayloadActionCreator } from "@reduxjs/toolkit";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

const {
  dispatch,
} = store;

export function useAppAction<P, A extends string>(creator: PayloadActionCreator<P, A>): PayloadActionCreator<P, A> {
  return useMemo(() => bindActionCreators(creator, dispatch), [dispatch]);
};
